export default {
  retrievePickupRouteList (state, payload) {
    state.pickupRouteList = [].concat(payload.pickupRouteList)
  },
  getPickupRouteInfo (state, payload) {
    state.pickupRouteInfo = payload.pickupRouteInfo

    if (state.pickupRouteInfo.bus_info === null) {
      state.pickupRouteInfo.bus_info = {
        id: ''
      }
    }

    if (state.pickupRouteInfo.parent_info === null) {
      state.pickupRouteInfo.parent_info = {
        id: ''
      }
    }

    state.selected = []

    for (const [key, value] of Object.entries(state.pickupRouteInfo.place_list)) {
      state.selected.push(value.id.toString())
    }

    state.selected = [].concat(state.selected)
  },

  deletePickupRoute (state, payload) {
    state.pickupRouteList.splice(payload.pickupRouteInfo.index, 1);
  },
  didSelectPlace (state, payload) {
    let selectData = payload.pickupRouteInfo.selectData

    let oldId = state.pickupRouteInfo.place_list[selectData[1]].id.toString()
    let oldIndex = state.selected.indexOf(oldId)

    if (oldIndex !== -1) {
      state.selected.splice(oldIndex, 1)
    }

    if (selectData[0] !== '-1') {
      state.selected.push(selectData[0])
    }

    state.pickupRouteInfo.place_list[selectData[1]].id = selectData[0]

    state.selected = [].concat(state.selected)
    state.pickupRouteInfo = Object.assign({}, state.pickupRouteInfo)
  },
  removePlace (state, payload) {
    let oldId = state.pickupRouteInfo.place_list[payload.data.index].id.toString()
    let oldIndex = state.selected.indexOf(oldId)

    if (oldIndex !== -1) {
      state.selected.splice(oldIndex, 1)
    }

    state.selected = [].concat(state.selected)
    state.pickupRouteInfo.place_list.splice(payload.data.index, 1)
  },
  addPlace (state, payload) {
    state.pickupRouteInfo.place_list.push({id:"-1"})
  },
  addStudent (state, payload) {
    state.pickupRouteStudentList.push({
      id: null,
      name: ''
    })
  },
  studentSet (state, payload) {
    state.pickupRouteStudentList[payload.index].id = payload.id
    state.pickupRouteStudentList[payload.index].name = payload.name
  },
  removeStudent (state, payload) {
    state.pickupRouteStudentList.splice(payload, 1)
  },
  updateState (state, payload) {
    state.currentFilter = payload.filter ? Object.assign({}, payload.filter) : null
    state.currentSort = payload.sort ? Object.assign({}, payload.sort) : null
    state.currentPage = payload.page ? payload.page : null
  }
}
